export class XmlHttpRequestHelper {
  static ajax(
    type: string,
    url: string,
    customHeaders: any,
    data: any,
    success: (result: any) => void,
    error?: (err: any) => void
  ): void {
    const xhr = new XMLHttpRequest();

    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status >= 200 && xhr.status < 300) {
          let result: any;
          try {
            result = JSON.parse(xhr.responseText);
          } catch {
            result = xhr.responseText;
          }
          success(result);
        } else {
          if (error) {
            error(xhr);
          }
        }
      }
    };

    const separator = url.indexOf('?') >= 0 ? '&' : '?';
    const cacheBusterUrl = `${url}${separator}d=${Date.now()}`;
    xhr.open(type, cacheBusterUrl, true);

    if (customHeaders) {
      for (const property in customHeaders) {
        if (Object.prototype.hasOwnProperty.call(customHeaders, property)) {
          xhr.setRequestHeader(property, customHeaders[property]);
        }
      }
    }

    xhr.setRequestHeader('Content-Type', 'application/json');
    if (data) {
      xhr.send(data);
    } else {
      xhr.send();
    }
  }
}
